import React, { Fragment, memo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'
import { Button } from 'src/components/shared/Button'
import { CommonModal } from 'src/components/shared/CommonModal'
import type { CreateCustomerFormValues } from './create-customer-form/CreateCustomerForm.interface'

interface Props {
  isOpen: boolean
  isSubmitting: boolean
  values: CreateCustomerFormValues | null
  onConfirm(): void
  onClose(): void
}

const ConfirmCreateCustomerModalComponent = ({
  isOpen,
  isSubmitting,
  values,
  onConfirm,
  onClose,
}: Props) => {
  if (!values) {
    return null
  }

  return (
    <CommonModal
      isOpen={isOpen}
      title="Create this customer?"
      onClose={onClose}
      buttons={
        <Fragment>
          <Button size="small" color="grey" onClick={onClose}>
            Cancel
          </Button>
          <Button
            size="small"
            color="primary"
            loading={isSubmitting}
            onClick={onConfirm}
            data-testid="create-customer-confirm-button"
          >
            Create customer
          </Button>
        </Fragment>
      }
    >
      <div css={tw`flex flex-col gap-1`}>
        <Typography variant="body2">Name: {values.name}</Typography>
        <Typography variant="body2">Logo: {values.logo ? values.logo.name : '—'}</Typography>
      </div>
    </CommonModal>
  )
}

export const ConfirmCreateCustomerModal = memo(ConfirmCreateCustomerModalComponent)
